export default {"src":"/_next/static/media/dog-branch.1e1ccf4f.svg","height":213,"width":447};